var DEFAULT_INPUT_LENGTH = 3;
export { DEFAULT_INPUT_LENGTH };
